import React, { useState, useEffect } from "react";
import Button from "@material-ui/core/Button";
import { useSetRecoilState } from 'recoil';
import { withStyles } from "@material-ui/core/styles";
import { grey } from "@material-ui/core/colors";

import * as AccountApi from "../../Common/Apis/AccountApi";
import { useAuth } from "../../../core/contexts/AuthContext";
import Spinner from "../../Common/UI/Spinner/Spinner";
import { useTheme } from "../../../core/contexts/ThemeContext";
import { RolePermissionState } from '../../../core/store/RolePermissionStore';


const ColorButton = withStyles((theme) => ({
  root: {
    color: theme.palette.getContrastText(grey[700]),
    backgroundColor: "#172b52",
    "&:hover": {
      backgroundColor: "#172b52",
    },
  },
}))(Button);



const Login = (props) => {


  const { rucmonkeyTheme } = useTheme();
  const setRolePermission = useSetRecoilState(RolePermissionState);
  const [userName, setUserName] = useState("");
  const [password, setPassword] = useState("");

  const { authTokens, setAuthTokens, menu } = useAuth();
  const [isLoading, setLoading] = useState(false);




  useEffect(() => {
    //console.log('login.init');
    setAuthTokens(null);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    let referer = props.location.state?.referer ?? "/locate";
    if (referer === "/") {
      referer = "/locate";
    }

    if (authTokens && menu) {
      const timeout = setTimeout(() => {
        try {
          props.history.push(referer);
        }
        catch (e) {
          console.log("Err.login", e);

          props.history.push("/");
        }

      }, 500);

      return () => {
        clearTimeout(timeout);
      };
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [authTokens, menu]);


  const processLogin = async (e) => {
    e.preventDefault();

    setLoading(true);

    try {
      const resData = await AccountApi.Login(userName, password);

      const userDetail = await AccountApi.getUserInformation({ access_token: resData.access_token });


      const menu = [];

      //const menu = await AccountApi.getMenu({ access_token: resData.access_token });

      //const permissions = await AccountApi.getLoginUserRolePermission({ access_token: resData.access_token });

      const rolePermissions = [];

      setRolePermission(rolePermissions);
      //const menuTree = setMenuTree(menu);
      const newToken = {
        ...resData,
        expires_in: Date.now() / 1000 + Number(resData.expires_in),
        user_email: userDetail.EmailAddress,
        user_name: userDetail.FirstName + " " + userDetail.LastName,
        account_name: userDetail.AccountName,
        menu: menu
      };

      setAuthTokens(newToken, menu, rolePermissions);

    } catch (_err) {
      //setLoading(false);
      alert("Id or password is invalid!");
    }

    setLoading(false);
  };

  if (!rucmonkeyTheme) return null;

  return (
    <>
      <div
        className="h-100  align-items-center log-in"
        style={{ display: "flex" }}
      >
        {/* <video playsInline autoPlay muted loop poster="polina.jpg" id="bgvid">
          <source src="/assets/video/circuit.webm" type="video/mp4" />
          <source src="/assets/video/circuit.mp4" type="video/mp4" />
        </video> */}
        <div className="container login-pannel">
          <div className="row no-gutters bg-lightblue">
            <div className="col-md-5 col-sm-12 align-self-center p-4">
              <div>
                <img width="80"
                  className="mx-auto d-block mb-3"
                  src="/assets/img/picoByte-logo-250.png"
                  alt="logo"
                />
                <p className="form-signin-title">
                  Data. Driven. Insights.
                </p>
              </div>
            </div>
            <div className="col-md-7 col-sm-12 align-self-center ">
              <form className="form-signin mx-auto p-4" onSubmit={processLogin}>
                <div className="text-center mb-4">
                  <h5 className="mb-3 font-weight-normal text-left">Sign In</h5>
                </div>

                <div className="form-label-group mb-4">
                  <input
                    type="email"
                    className="form-control"
                    placeholder="Email address"
                    onChange={(e) => setUserName(e.target.value)}
                    value={userName}
                  />
                </div>

                <div className="form-label-group mb-4" data-children-count="1">
                  <input
                    type="password"
                    className="form-control"
                    placeholder="Password"
                    onChange={(e) => setPassword(e.target.value)}
                    value={password}
                  />
                </div>

                <div className="row align-items-center">
                  <div className="col">
                    <p className="m-0">{/* Forgot password? */}</p>
                  </div>
                  <div className="col-auto">
                    <ColorButton className="btn btn-md " type="submit">
                      Sign in
                    </ColorButton>
                  </div>
                </div>
                <p className="mt-5 mb-3 text-muted text-center">
                  ©Picobyte Solutions 2019-2022
                </p>
                <p className="mt-0 mb-3 text-muted text-center">
                  Auckland | Sydney
                </p>
              </form>
            </div>
          </div>
        </div>

      </div>

      {isLoading && <Spinner active={true} />}
    </>
  );


};

export default Login;
